import ExpandMore from "@mui/icons-material/ExpandMore"
import FilterListIcon from "@mui/icons-material/FilterList"
import { InputAdornment, TextField } from "@mui/material"
import MenuItem from "@mui/material/MenuItem"
import { ChangeEvent, CSSProperties, useState } from "react"

import { getColorVariables } from "src/components/layouts/basic/BasicLayout.variables"
import { create } from "src/helpers/bem"

import styles from "./FilterSortSelector.module.scss"

const bem = create(styles, "FilterSortSelector")
const style = { ...getColorVariables(undefined) }

interface Option {
  id: string
  label: string
}
interface FilterSortSelectorProps {
  onChange: (value: string) => void
  options: Option[]
  value: string
  sizeVariant?: "small" | "medium" | "large"
  disabled?: boolean
}

export const FilterSortSelection = ({
  onChange,
  options,
  value,
  sizeVariant = "medium",
  disabled = false,
}: FilterSortSelectorProps) => {
  const [expanded, setExpanded] = useState<boolean>(false)
  const handleChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    onChange(event.target.value)
  }

  const selected: Option | undefined = options
    ? options.find((selected) => selected.id === value)
    : undefined

  return (
    <TextField
      select
      className={bem(undefined, sizeVariant)}
      defaultValue={value}
      disabled={disabled}
      variant="standard"
      InputProps={{
        inputProps: { className: bem("input") },
        disableUnderline: true,
        startAdornment: (
          <InputAdornment position="start">
            <FilterListIcon className={bem("icon")} fontSize="large" />
          </InputAdornment>
        ),
      }}
      SelectProps={{
        renderValue: () => <>{selected?.label}</>,
        onOpen: () => {
          setExpanded(true)
        },
        onClose: () => setExpanded(false),
        IconComponent: ExpandMore,
        MenuProps: {
          slotProps: { paper: { className: bem("wrapper", sizeVariant) } },
          MenuListProps: {
            className: bem("menu"),
            style: style as CSSProperties,
          },
        },
        className: bem("select", expanded ? "expanded" : ""),
      }}
      onChange={handleChange}
    >
      {options
        .filter((item) => item.id !== selected?.id)
        .map((option) => {
          return (
            <MenuItem
              key={option.id}
              className={bem("menuitem")}
              value={option.id}
            >
              {option.label}
            </MenuItem>
          )
        })}
    </TextField>
  )
}
